import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { JwtModule } from '@auth0/angular-jwt';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ENDPOINTS_CONFIG, EndpointsConfig } from '../app/config/endpoints.config';
import { AppConfigService } from '../app/helpers/app-init-config.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from '../app/shared/shared.module';
import { CoreModule } from '../app/core/core.module';
import { AppRoutingModule } from './app-routing.module';
/* 20240530 #19540 add start */
import { NgbModule, NgbDatepickerKeyboardService } from '@ng-bootstrap/ng-bootstrap';
/* 20240530 #19540 add end */
import { AppComponent } from './app.component';
/* 20240530 #19540 add start */
import { CustomKeyboardService } from './custom-keyboard.service'; 
/* 20240530 #19540 add end */
import { HomeComponent } from './modules/home/home.component';
import { ExampleComponent } from './modules/example/example.component';
import { StoreModule } from '@ngrx/store';
import { RoleGuardService } from './core/guard/role-guard.service';
import { LayoutModule } from './layout/layout.module';
import { BsDatepickerConfig, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsModalRef, ModalModule } from 'ngx-bootstrap/modal';
import { ngxLoadingAnimationTypes, NgxLoadingModule } from 'ngx-loading';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { appReducers } from './store/reducers/app.reducers';
import { InputTimeDirective } from './shared/directives/time.directive';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { NgbDatepickerI18n, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { EnterKeyDirective } from './shared/directives/enter-key.directive';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { LanguageDatepickerService } from './core/service/languageDatepicker.service';
import { HtmlCssComponent } from './modules/example/html-css/html-css.component';
import { InputDateDirective } from './shared/directives/date.directive';
import { AlphanumbericSymbolDirective } from './shared/directives/alphanumberic-symbol.directive';
import { ScrExamToppageComponent } from './modules/examinee/toppage/scr-exam-toppage/scr-exam-toppage.component';
import { SrcExamLoginComponent } from './modules/examinee/auth/src-exam-login/src-exam-login.component';
import { SrcPwResetComponent } from './modules/examinee/auth/src-pw-reset/src-pw-reset.component';
import { SrcPwForgotComponent } from './modules/examinee/auth/src-pw-forgot/src-pw-forgot.component';
import { SrcInterviewComponent } from './modules/interview/src-interview.component';
import { ScrUserInfInpComponent } from './modules/examinee/auth/scr-user-inf-inp/scr-user-inf-inp.component';
import { SrcPersonalInfComponent } from './modules/examinee/personal-inf/src-personal-inf.component';
import { SrcInsuranceSelComponent } from './modules/examinee/reservation-regis/src-insurance-sel/src-insurance-sel.component';
import { SrcInsuranceInpComponent } from './modules/examinee/reservation-regis/src-insurance-inp/src-insurance-inp.component';
import { SrcExamCourseSelComponent } from './modules/examinee/reservation-regis/src-exam-course-sel/src-exam-course-sel.component';
import { SrcReservationDateSelComponent } from './modules/examinee/reservation-regis/src-reservation-date-sel/src-reservation-date-sel.component';
import { SrcPersonalInfInpComponent } from './modules/examinee/reservation-regis/src-personal-inf-inp/src-personal-inf-inp.component';
import { SrcReservationDetailComponent} from './modules/examinee/reservation-regis/src-reservation-detail/src-reservation-detail.component';
import { SrcQuestionareAnsInpComponent} from './modules/examinee/questionare-inp/src-questionare-ans-inp/src-questionare-ans-inp.component';
import { ScrSendingAuthenMailComponent } from './modules/examinee/auth/scr-sending-authen-mail/scr-sending-authen-mail.component';
import { ErrorNotFoundComponent } from 'src/app/modules/error-not-found/error-not-found.component';

import { ScrExamInfInputComponent } from './modules/examinee/auth/scr-exam-inf-input/scr-exam-inf-input.component';
import { SrcExamResultComponent } from './modules/examinee/inspection-result/src-exam-result/src-exam-result.component';
import { DeactivateGuard } from './can-deactivate-guard.service';
import { AlphaSymbolHalfWidthDirective } from './shared/directives/alpha-symbol-halfwidth.directive';
import { BookingTermsComponent } from 'src/app/modules/terms-conditions/booking-terms.component';
import { ServiceTermsComponent } from 'src/app/modules/terms-conditions/service-terms.component';
export function initializeApp(appConfig: AppConfigService) {
  return () => appConfig.loadSetting();
}
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ExampleComponent,
    InputTimeDirective,
    EnterKeyDirective,
    EnterKeyDirective,
    HtmlCssComponent,
    InputDateDirective,
    AlphanumbericSymbolDirective,
    ScrExamToppageComponent,
    SrcExamLoginComponent,
    SrcPwResetComponent,
    SrcPwForgotComponent,
    SrcInterviewComponent,
    ScrUserInfInpComponent,
    SrcPersonalInfComponent,
    SrcInsuranceSelComponent,
    SrcInsuranceInpComponent,
    SrcExamCourseSelComponent,
    SrcReservationDateSelComponent,
    SrcPersonalInfInpComponent,
    SrcReservationDetailComponent,
    SrcQuestionareAnsInpComponent,
    SrcExamResultComponent,
    ScrSendingAuthenMailComponent,
    ErrorNotFoundComponent,
    ScrSendingAuthenMailComponent,
    ScrExamInfInputComponent,
    AlphaSymbolHalfWidthDirective,
    BookingTermsComponent,
    ServiceTermsComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    SharedModule,
    ReactiveFormsModule,
    CoreModule,
    HttpClientModule,
    StoreModule.forRoot(appReducers),
    LayoutModule,
    DragDropModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return localStorage.getItem('token');
        },
        allowedDomains: [],
        disallowedRoutes: []
      }
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    }),
    BsDatepickerModule.forRoot(),
    ModalModule.forRoot(),
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.circleSwish,
      fullScreenBackdrop: true,
      primaryColour: '#1CCE82',
      secondaryColour: '#1CCE82',
      tertiaryColour: '#1CCE82'
    }),
    PopoverModule.forRoot(),
    NgbDatepickerModule
	  /* 20240530 #19540 add start */
    ,NgbModule,
	  /* 20240530 #19540 add end */
  ],
  providers: [
    RoleGuardService, BsModalRef, DeactivateGuard,
    { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [AppConfigService], multi: true },
    { provide: ENDPOINTS_CONFIG, useValue: EndpointsConfig },
    { provide: BsDatepickerConfig, useFactory: getDatepickerConfig },
    { provide: NgbDatepickerI18n, useClass: LanguageDatepickerService },
    DatePipe,
    CurrencyPipe
	  /* 20240530 #19540 add start */
    ,{ provide: NgbDatepickerKeyboardService, useClass: CustomKeyboardService }
	  /* 20240530 #19540 add end */
  ],
  bootstrap: [AppComponent],

})
export class AppModule { }
// AOT compilation support
export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
export function getDatepickerConfig(): BsDatepickerConfig {
  return Object.assign(new BsDatepickerConfig(), {
    showWeekNumbers : false,
    monthTitle: 'YYYY / MM',
    monthLabel: 'M'
  });
}
